import * as api from '@/api'

export default {
  async generateOtp(payload) {
    let result = {}

    try {
      result = await api.auth.generateOtp(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async loginWithEmail(payload) {
    let result = {}

    try {
      result = await api.auth.loginWithEmail(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async loginWithSocial(payload) {
    let result = {}

    try {
      result = await api.auth.loginWithSocial(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  }
}
